import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTabItem} from '@Hooks/poster-editor/useGetKeyFromTabItem';

export function TabsBackgroundColorPanel(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemBgColor = useGetKeyFromTabItem('itemBackgroundColor');

  if (!activeItem) {
    throw new Error('Active Item is null');
  }

  if (!activeItem.isTab()) {
    throw new Error(`Expected tab item, instead got ${activeItem.gitype}`);
  }

  if (!itemBgColor) {
    throw new Error(`Expected tab item backgroundColor property, got null instead`);
  }

  const updateFillColor = (backgroundColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        itemBackgroundColor: backgroundColor,
      },
      {
        undoable,
      }
    );
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };
  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };

  const getColorObject = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor([itemBgColor]);
  };

  return (
    <PosterEditingBaseColorPanel
      isGradientEnabled={false}
      id="tabs-background-color-panel"
      color={getColorObject()}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeColorEnded}
    />
  );
}
